module.exports = __webpack_public_path__ + "img/Fs_Ui_Info_Orage_02.a410b3f6.png";